module.exports = __webpack_public_path__ + "static/media/black-speech-bubble-icon.992641d8.svg";